import React, { useEffect, useState, useRef } from 'react';
import CourseDetails2 from './CourseDetails2';
import './ManageCourses.css';
import { apiFetch } from "../api";

export default function ManageCourses({ semesters }) {
  const [degree, setDegree] = useState('');
  const [courseSemester, setCourseSemester] = useState('');
  const [season, setSeason] = useState('');
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const detailsRef = useRef(null);

  useEffect(() => {
    if (!degree || !courseSemester || !season) {
      setCourses([]);
      setFilteredCourses([]);
      setSelectedCourse(null);
      return;
    }

    apiFetch(
      `get_courses.php` +
      `?degree=${encodeURIComponent(degree)}` +
      `&semester=${encodeURIComponent(courseSemester)}` +
      `&season=${encodeURIComponent(season)}` +
      `&with_status=1`
    )
      .then(res => res.json())
      .then(data => {
        if (!Array.isArray(data)) {
          console.error('API-Error:', data);
          setCourses([]);
          return;
        }

        // Unterstützt sowohl alte String-Form als auch neue Objekt-Form
        const normalized = data.map(item => {
          if (typeof item === 'string') {
            return {
              course_title: item,
              manually_edited: 0
            };
          }
          return {
            course_title: item.course_title || '',
            manually_edited: Number(item.manually_edited) === 1 ? 1 : 0
          };
        });

        const sorted = [...normalized].sort((a, b) =>
          a.course_title.localeCompare(b.course_title, 'de', { sensitivity: 'base' })
        );

        setCourses(sorted);
      })
      .catch(err => {
        console.error(err);
        setCourses([]);
      });
  }, [degree, courseSemester, season]);

  useEffect(() => {
    if (!searchTerm) {
      setFilteredCourses(courses);
      return;
    }

    const lower = searchTerm.toLowerCase();
    setFilteredCourses(
      courses.filter(course =>
        course.course_title.toLowerCase().includes(lower)
      )
    );
  }, [searchTerm, courses]);

  useEffect(() => {
    if (selectedCourse && detailsRef.current) {
      detailsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [selectedCourse]);

  return (
    <div className="manage-courses">
      <h2>Bestehende Kurse verwalten</h2>

      <div className="filter-row">
        <select
          value={season}
          onChange={e => {
            setSeason(e.target.value);
            setSelectedCourse(null);
          }}
        >
          <option value="">— Aktives Semester —</option>
          {semesters.map(s => (
            <option key={s.id} value={s.short}>
              {s.name} ({s.short})
            </option>
          ))}
        </select>

        <select
          value={degree}
          onChange={e => {
            setDegree(e.target.value);
            setSelectedCourse(null);
            setCourseSemester('');
          }}
        >
          <option value="">— Studiengang —</option>
          <option value="Bachelor">Bachelor</option>
          <option value="Master">Master</option>
        </select>

        <select
          value={courseSemester}
          onChange={e => {
            setCourseSemester(e.target.value);
            setSelectedCourse(null);
          }}
        >
          <option value="">— Inhaltliches Semester —</option>
          {degree === 'Bachelor' && [1, 2, 3, 4, 5, 6].map(n => (
            <option key={n} value={n}>{n}</option>
          ))}
          {degree === 'Master' && [
            { val: 0, label: 'Ohne Semester (Master)' },
            { val: 1, label: '1' }
          ].map(opt => (
            <option key={opt.val} value={opt.val}>{opt.label}</option>
          ))}
        </select>
      </div>

      {courses.length > 0 && (
        <div className="search-row">
          <input
            type="text"
            className="search-input"
            placeholder="Suche Kurs-Titel…"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>
      )}

      {filteredCourses.length > 0 ? (
        <table className="courses-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Status</th>
              <th>Kurs-Titel</th>
            </tr>
          </thead>
          <tbody>
            {filteredCourses.map((course, idx) => (
              <tr
                key={course.course_title}
                className={selectedCourse === course.course_title ? 'selected' : ''}
              >
                <td>{idx + 1}</td>
                <td>
                  <span
                    title={course.manually_edited ? 'Bearbeitet' : 'Noch nicht bearbeitet'}
                    style={{
                      display: 'inline-block',
                      width: 12,
                      height: 12,
                      borderRadius: '50%',
                      background: course.manually_edited ? '#06A69E' : '#cbd5e1'
                    }}
                  />
                </td>
                <td>
                  <button onClick={() => setSelectedCourse(course.course_title)}>
                    {course.course_title}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        degree && courseSemester && season && (
          <p className="no-data">Keine Kurse gefunden.</p>
        )
      )}

      {selectedCourse && (
        <div ref={detailsRef} className="course-details-wrapper">
          <CourseDetails2
            title={selectedCourse}
            degree={degree}
            semester={courseSemester}
            semesters={semesters}
            season={season}
            mode="edit"
          />
        </div>
      )}
    </div>
  );
}